module.exports = __webpack_public_path__ + "img/med_logo.e9ccfa98.png";